<template>
<div class="list-chat">
  


       <!-- dont need an infinite list here... -->
    <div class="messages">
      <page-padding>
      <div v-if="!hasChat">{{$t('language.no_chat_messages')}}</div>
      

        <chat-baloon v-for="(item,index) in myMessages" :key="index+item.datetime" :item="item"/>
      
      </page-padding>   
    </div>
  

    
      <!--
        <button-talk v-for='(item,index) in teacher_talks[group_id+"talks"]' :item="item" :key="index"></button-talk>
       -->
</div>
</template>

<script>

//import ButtonTalk from '../talks/ButtonTalk.vue';
import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding.vue';
import { eventBus } from '../../services/EventBus';

import ChatBaloon from '../../components/chat/ChatBaloon.vue';

export default {
  name: 'list-chat',
  props:{
    person_id:{default:"0"},
    person_to:{},
  },
  data(){
    return {
      myMessages:{default:[]},
      polTimer:undefined,
      numMessages:0,
    }
  },
  computed:{
     ...mapState([
       'chat_messages'
       ]),
       hasChat:function(){
         // return chat[id]
         if(this.chat_messages['id_'+this.person_id]){
           return this.chat_messages['id_'+this.person_id].length;
         }else{
           return false;
         }
         
       },
  },
  components:{
    PagePadding,
    ChatBaloon,
  },
  methods:{
    
    loadChat(){
      
      // load for first time
      
      this.updateChat()
     
    },
    startChatPolling(){
      
      this.polTimer=setInterval(()=>{
        
        this.updateChat();
        
      },10000)
    },
    updateChat(){
  
        var options={
          store_key:"id_"+this.person_id,
          to_id:this.person_id,
          user_type:this.person_to.user_type
        }


        this.$store.dispatch('get_chat_messages',options).then(()=>{
          // setting my chat messages..
          this.myMessages=this.chat_messages["id_" + this.person_id];
          //resolve();
          this.numMessages=this.myMessages.length;
          
        })
      
      
    }
  },
  watch: { 
    numMessages: function() {
      // if messages are changed, scroll scrollpage to bottom.
      this.$nextTick(()=>{
        eventBus.$emit("SCROLL_TO_BOTTOM");
      })
    }
  },
  mounted:function(){
    this.$on('CHAT_MESSAGE_ADDED',this.updateChat);
    this.loadChat();
    this.startChatPolling();
  },
  beforeDestroy(){
    clearInterval(this.polTimer);
    this.$off('CHAT_MESSAGE_ADDED',this.updateChat);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list-chat{
  height:100%;
  display:flex;
  flex-direction: column;
}
.messages{
  flex:1;
}

</style>
